// |-- Built-in Dependencies --|
import React from "react";

// |-- External Dependencies --|
import { useSelector } from "react-redux";
import { object, string } from "yup";
import { Formik } from "formik";
import Dialog from "@mui/material/Dialog";

// |-- Internal Dependencies --|
import DispositionLevelTwoForm from "../Layout/DispositionLevelTwoForm";
import { showToast } from "src/utils/showToaster";
import { useAddDispositionLevelTwoMutation } from "src/services/DispositionLevelTwoServices";

// |-- Redux --|
import { RootState } from "src/redux/store";

// |-- Types --|
type Props = {
  onClose: () => void;
};

export type FormInitialValues = {
  dispositionLevelSecondName: string;
};

const AddDispositionLevelTwoFormWrapper = ({ onClose }: Props) => {
  const [addDispositionLevelTwo] = useAddDispositionLevelTwoMutation();
  const { selectedLocationCountries }: any = useSelector(
    (state: RootState) => state?.dispositionLevelOne
  );

  const initialValues: FormInitialValues = {
    dispositionLevelSecondName: "",
  };

  const validationSchema = object({
    dispositionLevelSecondName: string().required(
      "Disposition level second name is required"
    ),
  });

  const onSubmitHandler = (values: FormInitialValues) => {
    setTimeout(() => {
      addDispositionLevelTwo({
        dispositionFirstId: selectedLocationCountries?.value || "",
        dispositionSecondName: values.dispositionLevelSecondName,
      }).then((res: any) => {
        if ("data" in res) {
          if (res?.data?.status) {
            showToast("success", "added successfully!");
            onClose();
          } else {
            showToast("error", res?.data?.message);
          }
        } else {
          showToast("error", "Something went wrong");
        }
      });
    }, 1000);
  };

  return (
    <Dialog open maxWidth="xs" fullWidth>
      <Formik
        initialValues={initialValues}
        validationSchema={validationSchema}
        onSubmit={onSubmitHandler}
      >
        {(formikProps) => {
          return (
            <DispositionLevelTwoForm
              formType="Add"
              onClose={onClose}
              formikProps={formikProps}
            />
          );
        }}
      </Formik>
    </Dialog>
  );
};

export default AddDispositionLevelTwoFormWrapper;
